import '@/assets.v2/css/style.scss'
import { initPageSummaryV2 } from '@/pages-summary-v2/init'

initPageSummaryV2()
